import React, { Fragment, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import Button from "../../components/button";

const JobForm = () => {
    const minVal = 1;
    const maxVal = 100;
    var numberRegex = /^\d+$/;
    var DnumberRegex = /^\d*\.?\d*$/;

    const { register } = useForm({
        mode: "onChange", // Validates onChange
        defaultValues: {
            tenor: "tenorM",
        },
    });

    const [loanAmount, setLoanAmount] = useState(100000);
    const [loanAmountDis, setLoanAmountDis] = useState("100000");
    const [loanTenor, setLoanTenor] = useState(10);
    const [loanInterest, setLoanInterest] = useState(1);

    const [loanTenorMax, setLoanTenorMax] = useState(40);
    const [loanTenorMin, setLoanTenorMin] = useState(10);
    const [loanTenorName, setLoanTenorName] = useState("Mo");

    const [TotalIntPay, setTotalIntPay] = useState("19,500");
    const [TotalPayment, setTotalPayment] = useState("1,19,500");
    const [LoanEmiAmt, setLoanEmiAmt] = useState("6,639");
    const [LoanEmiAmtDaily, setLoanEmiAmtDaily] = useState("222");

    const handlesetLoanAmount = (event) => {
        fhandlesetLoanAmount(event.target.value);
    };

    const handlesetLoanTenor = (event) => {
        fhandlesetLoanTenor(event.target.value);
    };

    const handlesetLoanInterest = (event) => {
        fhandlesetLoanInterest(event.target.value);
    };

    const fhandlesetLoanAmount = (value) => {
        if (value >= 10000000) {
            setLoanAmount(10000000);
            l(10000000, loanInterest, loanTenor);
        } else if (value <= 100000) {
            setLoanAmount(100000);
            l(100000, loanInterest, loanTenor);
        } else {
            setLoanAmount(value) ? l() : "";
            // setLoanAmountDis(r(Math.round(value)));
            l(value, loanInterest, loanTenor);
        }
    };

    const fhandlesetLoanTenor = (value) => {
        if (value >= loanTenorMax) {
            setLoanTenor(loanTenorMax);
            l(loanAmount, loanInterest, loanTenorMax);
        } else if (value <= loanTenorMin) {
            setLoanTenor(loanTenorMin);
            l(loanAmount, loanInterest, loanTenorMin);
        } else {
            setLoanTenor(value);
            l(loanAmount, loanInterest, value);
        }
    };

    const fhandlesetLoanInterest = (value) => {
        if (value >= 50) {
            setLoanInterest(50);
            l(loanAmount, 50, loanTenor);
        } else if (value <= 1) {
            setLoanInterest(1);
            l(loanAmount, 1, loanTenor);
        } else {
            setLoanInterest(value);
            l(loanAmount, value, loanTenor);
        }
    };

    const handlesetLoanAmountTxt = (event) => {
        if (event.target.value) {
            if (numberRegex.test(event.target.value)) {
                setLoanAmount(event.target.value.replace(/^0+/, ""));
                if (event.target.value >= 10000000) {
                    setLoanAmount(10000000);
                    fhandlesetLoanAmount(10000000);
                } else if (event.target.value <= 100000) {
                } else if (event.target.value) {
                    fhandlesetLoanAmount(event.target.value);
                }
            }
        } else {
            setLoanAmount(0);
        }
    };

    const handlesetLoanTenortxt = (event) => {
        if (event.target.value) {
            if (numberRegex.test(event.target.value)) {
                setLoanTenor(event.target.value.replace(/^0+/, ""));
                if (event.target.value >= loanTenorMax) {
                    setLoanTenor(loanTenorMax);
                    fhandlesetLoanTenor(loanTenorMax);
                } else if (event.target.value <= loanTenorMin) {
                } else {
                    fhandlesetLoanTenor(event.target.value);
                }
            }
        } else {
            setLoanTenor(0);
        }
    };

    const handlesetLoanInterestTxt = (event) => {
        // setLoanInterest(event.target.value);
        if (event.target.value) {
            if (DnumberRegex.test(event.target.value)) {
                setLoanInterest(event.target.value.replace(/^0+/, ""));
                if (event.target.value >= 50) {
                    setLoanInterest(50);
                    fhandlesetLoanInterest(50);
                } else if (event.target.value <= 1) {
                } else {
                    fhandlesetLoanInterest(event.target.value);
                }
            }
        } else {
            setLoanInterest(0);
        }
    };

    const handlesetTenor = (event) => {
        if (event.target.value == "tenorM") {
            setLoanTenorName("Mo");
            setLoanTenorMax(40);
            setLoanTenorMin(10);
            fhandlesetLoanTenor(10);
        } else {
            setLoanTenorName("Y");
            setLoanTenorMax(20);
            setLoanTenorMin(5);
            fhandlesetLoanTenor(5);
        }
    };

    const handleBlur = (val) => {
        if (val) {
            const number = parseFloat(val);
            if (!isNaN(number)) {
                const formatter = new Intl.NumberFormat("en-IN", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                });
                setLoanAmountDis(formatter.format(number));
            }
        }
    };

    function l(la, li, lt) {
        loanTenorName == "Y" ? (lt = lt * 12) : lt;
        var e = la,
            a = li;
        a /= 100;
        var l = lt;

        var i = a,
            n = (Number((e * a * l) / 12) + Number(e)) / Number(l),
            s = Math.round(n),
            DailyAmount = Math.ceil(s / 30);

        setLoanEmiAmtDaily(r(Math.round(DailyAmount)));
        setLoanEmiAmt(r(Math.round(s)));

        t(e, i, l);
    }

    function t(e, a, t) {
        var p = e;
        var c = (p * t * a) / 12;

        var f = r(Math.round(c));
        setTotalIntPay(f);

        var g = Number(p) + Number(c),
            b = r(Math.round(g));
        setTotalPayment(b);
    }

    function r(e) {
        (e = e.toString()).indexOf(",") > -1 && (e = e.replace(/\,/g, ""));
        var a = e.replace(/\D/g, "").substring(e.length - 3),
            t = e.substring(0, e.length - 3);
        return (
            "" != t && (a = "," + a),
            t.replace(/\D/g, "").replace(/\B(?=(\d{2})+(?!\d))/g, ",") + a
        );
    }

    return (
        <div className="row">
            <div className="col-12 col-sm-12 col-lg-6 mb-7">
                <div className="col-12 col-sm-12 col-lg-12 mb-7">
                    <div className="col-12 mb-7">
                        <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between">
                            <label
                                htmlFor="loanAmountTxt"
                                className="form-label"
                            >
                                Loan Amount
                            </label>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3 ">
                                <div className="input-group mb-3">
                                    <span
                                        className="input-group-text"
                                        id="ruppe"
                                        style={{
                                            padding: "0.1975rem 0.4375rem",
                                        }}
                                    >
                                        ₹
                                    </span>

                                    <input
                                        type="text"
                                        id="loanAmountTxt"
                                        name="loanAmountTxt"
                                        value={loanAmount}
                                        onChange={handlesetLoanAmountTxt}
                                        className="form-control"
                                        style={{
                                            textAlign: "end",
                                            padding: "0.1975rem 0.4375rem",
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <input
                            type="range"
                            className="form-range"
                            min="100000"
                            max="10000000"
                            id="loanAmountTxt"
                            value={loanAmount}
                            onChange={handlesetLoanAmount}
                        ></input>
                    </div>
                </div>

                <div className="col-12 mb-7">
                    <div className="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center">
                        {/* Tenure Section */}
                        <fieldset className="form-group col-12 col-sm-8 mb-3 mb-sm-0">
                            <legend
                                className="form-label fs-6 mb-2"
                                style={{ width: "auto" }}
                            >
                                Tenure
                            </legend>

                            <div className="d-flex align-items-center gap-4">
                                <div className="form-check">
                                    <input
                                        type="radio"
                                        id="tenorM"
                                        value="tenorM"
                                        {...register("tenor")}
                                        onChange={handlesetTenor}
                                        className="form-check-input"
                                        style={{
                                            transform: "scale(1.2)",
                                            accentColor: "green",
                                        }}
                                    />
                                    <label
                                        htmlFor="tenorM"
                                        className="form-check-label ms-2"
                                    >
                                        Months
                                    </label>
                                </div>

                                <div className="form-check">
                                    <input
                                        type="radio"
                                        id="tenorY"
                                        value="tenorY"
                                        {...register("tenor")}
                                        onChange={handlesetTenor}
                                        className="form-check-input"
                                        style={{
                                            transform: "scale(1.2)",
                                            accentColor: "green",
                                        }}
                                    />
                                    <label
                                        htmlFor="tenorY"
                                        className="form-check-label ms-2"
                                    >
                                        Years
                                    </label>
                                </div>
                            </div>
                        </fieldset>

                        {/* Input Box */}
                        <div className="col-12 col-sm-4 col-md-3 col-lg-2">
                            <div className="input-group">
                                <input
                                    type="text"
                                    id="loanTenorTxt"
                                    name="loanTenorTxt"
                                    value={loanTenor}
                                    onChange={handlesetLoanTenortxt}
                                    className="form-control"
                                    style={{
                                        textAlign: "end",
                                        padding: "0.1975rem 0.4375rem",
                                    }}
                                />
                                <span
                                    className="input-group-text"
                                    id="tname"
                                    style={{
                                        padding: "0.1975rem 0.4375rem",
                                    }}
                                >
                                    {loanTenorName}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Slider */}
                    <input
                        type="range"
                        className="form-range mt-3"
                        min={loanTenorMin}
                        max={loanTenorMax}
                        id="loanTenorRange"
                        value={loanTenor}
                        onChange={handlesetLoanTenor}
                    />
                </div>

                <div className="col-12 col-sm-12 col-lg-12 mb-7">
                    <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between">
                        <label htmlFor="loanInterestTxt" className="form-label">
                            Rate of Interest
                        </label>
                        <div className="col-12 col-sm-6 col-lg-3 col-md-4">
                            <div className="input-group mb-3">
                                <input
                                    type="text"
                                    id="loanInterestTxt"
                                    name="loanInterestTxt"
                                    value={loanInterest}
                                    onChange={handlesetLoanInterestTxt}
                                    className="form-control"
                                    style={{
                                        textAlign: "end",
                                        padding: "0.1975rem 0.4375rem",
                                    }}
                                />
                                <span
                                    className="input-group-text"
                                    id="percetn"
                                    style={{
                                        padding: "0.1975rem 0.4375rem",
                                    }}
                                >
                                    %
                                </span>
                            </div>
                        </div>
                    </div>
                    <input
                        type="range"
                        className="form-range"
                        min="1"
                        max="50"
                        step={0.25}
                        id="loanInterestTxt"
                        value={loanInterest}
                        onChange={handlesetLoanInterest}
                    ></input>
                </div>
            </div>
            <div className="col-12 col-sm-12 col-lg-6 mb-7">
                <div className="g-background-color align-content-center radius-box p-2 m-2 d-flex d-flex justify-content-between">
                    <div className="align-content-center mx-3">
                        <h2 className="fs-6">Total Interest</h2>
                    </div>
                    <div className=" text-end me-3">
                        <div className="g-color fs-5">
                            <b>₹{TotalIntPay}</b>
                        </div>
                    </div>
                </div>
                <div className="y-background-color align-content-center radius-box p-2 m-2 d-flex justify-content-between">
                    <div className="col-lg-7 col-sm-4 align-content-center mx-3">
                        <h2 className="fs-6">
                            Total Payable (Principle + Interest)
                        </h2>
                    </div>
                    <div className=" text-end me-3">
                        <div className="g-color fs-5">
                            <b>₹{TotalPayment}</b>
                        </div>
                    </div>
                </div>
                <div className="g-background-color align-content-center radius-box p-2 m-2 d-flex justify-content-between">
                    <div className="col-lg-7 col-sm-4 align-content-center mx-3">
                        <h2 className="fs-6">Monthly EMI</h2>
                    </div>
                    <div className=" text-end me-3">
                        <div className="g-color fs-5">
                            <b>₹{LoanEmiAmt}</b>
                        </div>
                    </div>
                </div>
                <div className="y-background-color align-content-center radius-box p-2 m-2 d-flex justify-content-between">
                    <div className="col-lg-7 col-sm-4 align-content-center mx-3">
                        <h2 className="fs-6">Daily Repayment Amount</h2>
                    </div>
                    <div className=" text-end me-3">
                        <div className="g-color fs-5">
                            <b>₹{LoanEmiAmtDaily}</b>
                        </div>
                    </div>
                </div>

                <div className=" d-flex justify-content-between radius-box p-2 m-2 text-center">
                    <Button
                        classOption="btn btn-sm btn-warning btn-hover-warning"
                        text="Explore Our Products"
                        path={"products"}
                    />
                    <Button
                        classOption="btn btn-sm btn-primary btn-hover-primary"
                        text="Apply Now"
                        path={"loan-details"}
                    />
                </div>
            </div>
            <div
                role="status"
                aria-live="polite"
                aria-atomic="true"
                className="visually-hidden"
            >
                EMI updated. <br></br>
                <span>Loan AmountI: ₹{loanAmount}</span>
                <br></br>
                <span>
                    Tenure: {loanTenor}
                    {loanTenorName}
                </span>
                <br></br>
                <span>
                    Rate of Interest: {loanInterest}
                    {"%"}
                </span>
                <br></br>
                <span>Total Interest: ₹{TotalIntPay}.</span>
                <br></br>
                <span>
                    Total Payable (Principle + Interest): ₹{TotalPayment}.
                </span>
                <br></br>
                <span>Monthly EMI: {LoanEmiAmt}</span>
                <br></br>
                <span>Daily Repayment Amount: ₹{LoanEmiAmtDaily}</span>
            </div>
        </div>
    );
};

export default JobForm;
